export default __webpack_public_path__ + "static/media/firefox-icon.ebb2d80e.svg";